// import React, { useState } from 'react'
// import { FaFileSignature } from "react-icons/fa";
// import { FaMobileRetro } from "react-icons/fa6";
// import { FaAnglesRight } from "react-icons/fa6";
// import { MdGroups } from "react-icons/md";
// import CampainModal from './campainModal';
// import { BsUpload } from "react-icons/bs";
// import { TbArrowsSort } from "react-icons/tb";




// function Campaigndetails({setTemplateimformatios}) {
//     const today = new Date()
//         .toLocaleString("en-GB", {
//             day: "2-digit",
//             month: "short",
//             year: "numeric",
//             hour: "2-digit",
//             minute: "2-digit",
//             second: "2-digit",
//             hour12: false,
//         })
//         .replace(",", "");

//     const [open, setOpen] = useState(false);
//     const [isfile, setisfile] = useState(false);
//     const [Today, setToday] = useState(today)
//     const [Numbers, setNumbers] = useState('')
//     const [group, setgroup] = useState('')

//     const [Schedule, setSchedule] = useState(false);
//     const [BlackList, setBlackList] = useState(false);
//     const [Duplicates, setDuplicates] = useState(false);
  

//     console.log(open)
//     return (
//         <>
//             <div className='w-[100%] shadow-[0px_5px_15px_0px_rgba(0,0,0,0.15)] p-3 md:p-4 rounded-md mt-4'>

//                 <div className='w-[100%] border-b-[1px] border-[#dfdfdf] pb-1 flex items-center gap-1'>
//                     <p className='text-[#121519] font-semibold text-[16px] md:text-[18px] dark:text-[#fff]'>
//                         Campaign Details 📲
//                     </p>
//                 </div>

//                 <div className='mt-[20px]'>

//                     <div>
//                         <p className='flex items-center text-[13px] font-[500] gap-1 dark:text-[#fff]'>
//                             <FaFileSignature /> Campaign Name <span className='text-red-600'>*</span>
//                         </p>
//                         <p className='text-[12px] text-[#808080] dark:text-[#fff]'>
//                             Pick something that describes your audience & goals.
//                         </p>

//                         <input
//                             className="border border-[#d4cfcf] text-[#454546] font-medium bg-white dark:border-[#251f1f] dark:text-[#e2dbdb] w-[100%] md:w-[50%] p-1 rounded-md text-[13px] mt-1 outline-none dark:bg-[#121519]"
//                             type="text"
//                             value={Today}
//                         />
//                     </div>

//                     <div>
//                         <div className='w-[100%] flex flex-col md:flex-row md:justify-between'>
//                             <p className='flex items-center text-[13px] font-[500] gap-1 mt-4 dark:text-[#fff]'>
//                                 <FaMobileRetro /> Numbers <span className='text-red-600'>*</span>
//                             </p>
//                             <span className='flex items-center text-[13px] font-[500] gap-1 mt-2 md:mt-4'>
//                                 <FaAnglesRight /> Total Count ( 0 )
//                             </span>
//                         </div>

//                         <textarea
//                             className="border border-[#d4cfcf] text-[#454546] font-medium bg-white dark:border-[#251f1f] dark:text-[#e2dbdb] w-[100%] p-1 rounded-md text-[13px] mt-1 outline-none dark:bg-[#121519]"
//                             placeholder='Enter multiple numbers separated by commas. Max 5,000 allowed.'
//                             rows="4"
//                             value={Numbers}
//                             onChange={(e) => {
//                                 setNumbers(e.target.value)
//                             }}
//                         />

//                         <p className='text-[12px] text-[#808080]'>
//                             Enter multiple numbers separated by commas. Max 5,000 allowed.
//                         </p>

//                         <div className='flex flex-col sm:flex-row gap-3 sm:gap-4 mt-5'>
//                             <button
//                                 onClick={() => setOpen(true)}
//                                 className='flex items-center justify-center border-[1px] border-[#37715d] rounded-lg p-2 text-[#37715d] gap-2 hover:bg-[#37715d] hover:text-[#fff] w-full sm:w-auto'>
//                                 <MdGroups /> <span className='text-[12px] font-bold'>Group</span>
//                             </button>

//                             <button
//                                 onClick={() => setisfile(true)}
//                                 className='flex items-center justify-center border-[1px] border-[#37715d] rounded-lg p-2 text-[#37715d] gap-2 hover:bg-[#37715d] hover:text-[#fff] w-full sm:w-auto'>
//                                 <BsUpload /> <span className='text-[12px] font-bold'>Upload File</span>
//                             </button>
//                         </div>

//                         <div className='flex flex-col sm:flex-row flex-wrap mt-4 gap-4'>

//                             <div className='flex gap-1 items-center'>
//                                 <button
//                                     onClick={() => setDuplicates(!Duplicates)}
//                                     className={`w-[30px] h-[12px] flex items-center rounded-[50px] transition duration-300 ${Duplicates ? "bg-[#37715d]" : "bg-[#b4bbc3]"}`}>
//                                     <div
//                                         className={`bg-[#fff] w-[10px] h-[10px] rounded-full shadow-md transform transition ml-[1px] ${Duplicates ? "translate-x-[18px]" : ""}`}>
//                                     </div>
//                                 </button>
//                                 <span onClick={() => setDuplicates(!Duplicates)} className='text-[#576071] font-[600] text-[13px]'>
//                                     Remove Duplicates
//                                 </span>
//                             </div>

//                             <div className='flex gap-1 items-center'>
//                                 <button
//                                     onClick={() => setBlackList(!BlackList)}
//                                     className={`w-[30px] h-[12px] flex items-center rounded-[50px] transition duration-300 ${BlackList ? "bg-[#37715d]" : "bg-[#b4bbc3]"}`}>
//                                     <div
//                                         className={`bg-[#fff] w-[10px] h-[10px] rounded-full shadow-md transform transition ml-[1px] ${BlackList ? "translate-x-[18px]" : ""}`}>
//                                     </div>
//                                 </button>
//                                 <span onClick={() => setBlackList(!BlackList)} className='text-[#576071] font-[600] text-[13px]'>
//                                     Remove BlackList
//                                 </span>
//                             </div>

//                             <div className='flex gap-1 items-center'>
//                                 <button
//                                     onClick={() => setSchedule(!Schedule)}
//                                     className={`w-[30px] h-[12px] flex items-center rounded-[50px] transition duration-300 ${Schedule ? "bg-[#37715d]" : "bg-[#b4bbc3]"}`}>
//                                     <div
//                                         className={`bg-[#fff] w-[10px] h-[10px] rounded-full shadow-md transform transition ml-[1px] ${Schedule ? "translate-x-[18px]" : ""}`}>
//                                     </div>
//                                 </button>
//                                 <span onClick={() => setSchedule(!Schedule)} className='text-[#576071] font-[600] text-[13px]'>
//                                     Schedule Now
//                                 </span>
//                             </div>

//                         </div>

//                         <div className='flex w-[100%] justify-center md:justify-end mt-4'>
//                             <button
//                                 onClick={()=> setTemplateimformatios(true)}
                                
//                                 className={`flex items-center border-[1px] rounded-lg px-4 py-2 gap-2 text-[12px] font-bold w-full md:w-auto justify-center
//     ${Numbers.length == 0
//                                         ? 'bg-[#37715d]/50  text-white cursor-not-allowed'
//                                         : 'bg-[#37715d] border-[#37715d] text-white hover:bg-[#2f5e4e]'
//                                     }`}
//                             >
//                                 Next
//                             </button>
//                         </div>

//                     </div>
//                 </div>
//             </div>
//             <CampainModal isOpen={open} onClose={() => setOpen(false)} group={group}>
//                 <div className='w-[100%] flex flex-col mt-5'>
//                     <span className='text-[#121519] font-semibold text-[13px]'>Search Group</span>
//                     <input className="
//     border border-[#d4cfcf] text-[#454546] font-medium bg-white dark:border-[#251f1f] dark:bg-[#32303 dark:text-[#e2dbdb] w-[100%] p-1 rounded-md text-[13px] mt-1 outline-none"
//                         type="text"
//                         placeholder='Enter Group Name'
//                         value={group}
//                         onChange={(e) => {
//                             setgroup(e.target.value)
//                         }}
//                     />
//                 </div>
//                 <table className="w-full   overflow-hidden border-[1px] border-[#dee2e6] mt-4">
//                     <thead className="">
//                         <tr className="text-left text-sm font-semibold text-gray-700">

//                             <th className="p-2 border-[1px] border-[#dee2e6]"></th>

//                             <th className="p-2  cursor-pointer border-[1px] border-[#dee2e6] ">
//                                 <div className="flex justify-between items-center gap-2">
//                                     <span className='text-[13px] text-[#576071]'>Group Name</span>
//                                     <button type="button" className="text-gray-500 hover:text-black">
//                                         <TbArrowsSort />
//                                     </button>
//                                 </div>
//                             </th>

//                             <th className="p-2 border-[1px] border-[#dee2e6] cursor-pointer ">
//                                 <div className="flex justify-between items-center gap-2">
//                                     <span className='text-[13px] text-[#576071]'>Total Contacts</span>
//                                     <button type="button" className="text-gray-500 hover:text-black">
//                                         <TbArrowsSort />
//                                     </button>
//                                 </div>
//                             </th>

//                         </tr>
//                     </thead>

//                     <tbody>
//                         <tr class="text-center text-gray-500 bg-[#f6f9fc]">
//                             <td colspan="3" className="p-1">
//                                 No data found
//                             </td>
//                         </tr>
//                     </tbody>
//                 </table>

//                 <p className='text-[13px] text-[#3f7fc8] mt-2' >Showing 1 to 0 of 0 records</p>
//                 <div className='w-[100%] flex justify-end'
//                 > <button
//                     className='flex items-center border-[1px] border-[#37715d] rounded-lg px-4 py-2 gap-2 bg-[#37715d]  text-[#fff]'>
//                         <span className='text-[12px] font-bold'>Save</span>
//                     </button></div>
//             </CampainModal>
//             <CampainModal isOpen={isfile} onClose={() => setisfile(false)} >

//             </CampainModal>
//         </>
//     )
// }

// export default Campaigndetails

// import React, { useState } from 'react'
// import { FaBullhorn } from "react-icons/fa";
// import { FaUsers } from "react-icons/fa";
// import { MdPhoneAndroid } from "react-icons/md";
// import { RxCross1 } from "react-icons/rx";

// function Campaigndetails({ campaignData, setCampaignData, whatsappData, onNext }) {

//     // Local state for number input
//     const [numberInput,  setNumberInput]  = useState('');
//     const [numberError,  setNumberError]  = useState('');
//     const [bulkInput,    setBulkInput]    = useState('');  // paste many numbers
//     const [showBulk,     setShowBulk]     = useState(false);

//     const update = (key, value) => setCampaignData(prev => ({ ...prev, [key]: value }));

//     // ── Add a single number ───────────────────────────────────────────────
//     const addNumber = () => {
//         const cleaned = numberInput.trim().replace(/\D/g, '');
//         if (!cleaned) return;
//         if (cleaned.length < 7 || cleaned.length > 15) {
//             setNumberError('Number must be 7–15 digits.');
//             return;
//         }
//         if (campaignData.numbers.includes(cleaned)) {
//             setNumberError('Number already added.');
//             return;
//         }
//         update('numbers', [...campaignData.numbers, cleaned]);
//         setNumberInput('');
//         setNumberError('');
//     };

//     // ── Add bulk numbers (comma / newline separated) ──────────────────────
//     const addBulkNumbers = () => {
//         const lines = bulkInput.split(/[\n,]+/).map(n => n.trim().replace(/\D/g, '')).filter(n => n.length >= 7 && n.length <= 15);
//         const unique = [...new Set([...campaignData.numbers, ...lines])];
//         update('numbers', unique);
//         setBulkInput('');
//         setShowBulk(false);
//     };

//     const removeNumber = (n) => update('numbers', campaignData.numbers.filter(x => x !== n));

//     const canProceed = campaignData.campaignName.trim() && campaignData.phoneNumberId && campaignData.numbers.length > 0;

//     return (
//         <div className='w-[100%] shadow-[0px_5px_15px_0px_rgba(0,0,0,0.15)] p-3 md:p-4 rounded-md mt-4'>
//             <div className='w-[100%] border-b-[1px] border-[#dfdfdf] pb-1 mb-4'>
//                 <p className='text-[#121519] font-semibold text-[16px] md:text-[18px] dark:text-[#fff]'>
//                     Campaign Details 📋
//                 </p>
//             </div>

//             <div className='flex flex-wrap gap-4'>
//                 {/* Campaign Name */}
//                 <div className='w-full sm:w-[48%]'>
//                     <label className='text-[13px] font-semibold text-[#374151] dark:text-[#fff] flex items-center gap-1 mb-1'>
//                         <FaBullhorn className='text-[#ed7b00]' /> Campaign Name <span className='text-red-500'>*</span>
//                     </label>
//                     <input
//                         type="text"
//                         placeholder='e.g. April Promo 2025'
//                         value={campaignData.campaignName}
//                         onChange={(e) => update('campaignName', e.target.value)}
//                         className='border border-[#d4cfcf] text-[#454546] bg-white dark:bg-[#121519] dark:text-[#fff] w-full p-2 rounded-md text-[13px] outline-none'
//                     />
//                 </div>

//                 {/* WhatsApp Channel */}
//                 <div className='w-full sm:w-[48%]'>
//                     <label className='text-[13px] font-semibold text-[#374151] dark:text-[#fff] flex items-center gap-1 mb-1'>
//                         <MdPhoneAndroid className='text-[#ed7b00]' /> WhatsApp Channel <span className='text-red-500'>*</span>
//                     </label>
//                     <select
//                         value={campaignData.phoneNumberId}
//                         onChange={(e) => {
//                             const selected = whatsappData.find(d => d.phone_number_id === e.target.value);
//                             setCampaignData(prev => ({
//                                 ...prev,
//                                 phoneNumberId: e.target.value,
//                                 wabaId:        selected?.waba_id        || '',
//                                 channelLabel:  selected?.['Display Name'] || e.target.value,
//                             }));
//                         }}
//                         className='border border-[#d4cfcf] text-[#454546] bg-white dark:bg-[#121519] dark:text-[#fff] w-full p-2 rounded-md text-[13px] outline-none'
//                     >
//                         <option value="">Select Channel</option>
//                         {whatsappData.map(d => (
//                             <option key={d.phone_number_id} value={d.phone_number_id}>
//                                 {d['Display Name'] || d.phone_number_id} ({d.phone_number_id})
//                             </option>
//                         ))}
//                     </select>
//                 </div>

//                 {/* Group Name (optional) */}
//                 <div className='w-full sm:w-[48%]'>
//                     <label className='text-[13px] font-semibold text-[#374151] dark:text-[#fff] flex items-center gap-1 mb-1'>
//                         <FaUsers className='text-[#ed7b00]' /> Group Name <span className='text-[11px] text-[#808080] font-normal'>(optional)</span>
//                     </label>
//                     <input
//                         type="text"
//                         placeholder='e.g. VIP Customers'
//                         value={campaignData.groupName}
//                         onChange={(e) => update('groupName', e.target.value)}
//                         className='border border-[#d4cfcf] text-[#454546] bg-white dark:bg-[#121519] dark:text-[#fff] w-full p-2 rounded-md text-[13px] outline-none'
//                     />
//                 </div>

//                 {/* Schedule (optional) */}
//                 <div className='w-full sm:w-[48%]'>
//                     <label className='text-[13px] font-semibold text-[#374151] dark:text-[#fff] mb-1 block'>
//                         Schedule <span className='text-[11px] text-[#808080] font-normal'>(optional — leave blank to send now)</span>
//                     </label>
//                     <input
//                         type="datetime-local"
//                         value={campaignData.scheduledTime}
//                         onChange={(e) => update('scheduledTime', e.target.value)}
//                         className='border border-[#d4cfcf] text-[#454546] bg-white dark:bg-[#121519] dark:text-[#fff] w-full p-2 rounded-md text-[13px] outline-none'
//                     />
//                 </div>

//                 {/* Phone numbers */}
//                 <div className='w-full'>
//                     <label className='text-[13px] font-semibold text-[#374151] dark:text-[#fff] flex items-center gap-1 mb-1'>
//                         <MdPhoneAndroid className='text-[#ed7b00]' /> Recipient Numbers <span className='text-red-500'>*</span>
//                         <span className='ml-auto text-[11px] text-[#808080] font-normal'>{campaignData.numbers.length} added</span>
//                     </label>

//                     {/* Single number input */}
//                     <div className='flex gap-2 mb-2'>
//                         <input
//                             type="text"
//                             placeholder='e.g. 919664176950 (with country code, digits only)'
//                             value={numberInput}
//                             onChange={(e) => { setNumberInput(e.target.value); setNumberError(''); }}
//                             onKeyDown={(e) => e.key === 'Enter' && addNumber()}
//                             className='flex-1 border border-[#d4cfcf] text-[#454546] bg-white dark:bg-[#121519] dark:text-[#fff] p-2 rounded-md text-[13px] outline-none'
//                         />
//                         <button onClick={addNumber}
//                             className='px-3 py-2 bg-[#ed7b00] hover:bg-[#006857] text-white text-[13px] font-semibold rounded-md'>
//                             Add
//                         </button>
//                         <button onClick={() => setShowBulk(!showBulk)}
//                             className='px-3 py-2 bg-[#edf1f5] hover:bg-[#d3dde6] text-[#434a57] text-[13px] font-semibold rounded-md'>
//                             Bulk
//                         </button>
//                     </div>
//                     {numberError && <p className='text-[12px] text-red-500 mb-2'>{numberError}</p>}

//                     {/* Bulk paste */}
//                     {showBulk && (
//                         <div className='mb-3 p-3 border border-[#d4cfcf] rounded-lg bg-[#f9fafb]'>
//                             <p className='text-[12px] text-[#808080] mb-2'>Paste numbers separated by commas or new lines (with country code, digits only)</p>
//                             <textarea
//                                 rows={4}
//                                 value={bulkInput}
//                                 onChange={(e) => setBulkInput(e.target.value)}
//                                 placeholder={'919664176950\n919783555015\n...'}
//                                 className='w-full border border-[#d4cfcf] p-2 rounded-md text-[13px] outline-none resize-none'
//                             />
//                             <div className='flex justify-end gap-2 mt-2'>
//                                 <button onClick={() => setShowBulk(false)}
//                                     className='px-3 py-1.5 bg-[#edf1f5] text-[#434a57] text-[12px] font-semibold rounded-md'>Cancel</button>
//                                 <button onClick={addBulkNumbers}
//                                     className='px-3 py-1.5 bg-[#ed7b00] text-white text-[12px] font-semibold rounded-md'>Add Numbers</button>
//                             </div>
//                         </div>
//                     )}

//                     {/* Number tags */}
//                     {campaignData.numbers.length > 0 && (
//                         <div className='flex flex-wrap gap-2 max-h-[120px] overflow-y-auto p-2 border border-[#eee] rounded-lg bg-[#f9fafb]'>
//                             {campaignData.numbers.map((n, i) => (
//                                 <span key={i} className='flex items-center gap-1 text-[11px] bg-white border border-[#d4cfcf] px-2 py-1 rounded-full text-[#374151]'>
//                                     {n}
//                                     <button onClick={() => removeNumber(n)} className='text-[#ed5050] hover:text-red-700 ml-0.5'>
//                                         <RxCross1 size={10} />
//                                     </button>
//                                 </span>
//                             ))}
//                         </div>
//                     )}
//                 </div>
//             </div>

//             {/* Next button */}
//             <div className='flex justify-end mt-6'>
//                 <button
//                     onClick={onNext}
//                     disabled={!canProceed}
//                     className={`flex items-center gap-2 px-4 py-2 rounded-lg text-[13px] font-bold text-white
//                         ${!canProceed
//                             ? 'bg-[#37715d]/50 cursor-not-allowed'
//                             : 'bg-[#ed7b00] hover:bg-[#006857]'
//                         }`}
//                 >
//                     Next →
//                 </button>
//             </div>
//         </div>
//     );
// }

// export default Campaigndetails;

import { useState, useRef, useEffect } from "react";
import * as XLSX from "xlsx";
import { FaUser, FaUsers, FaFileExcel, FaKeyboard, FaTrash, FaCheckCircle, FaExclamationTriangle, FaChevronDown, FaDownload } from "react-icons/fa";

// ── Country code → expected local number length ──────────────────────────────
const COUNTRY_LENGTHS = {
  "1": 10, "7": 10, "20": 10, "27": 9, "30": 10, "31": 10, "32": 9,
  "33": 9, "34": 9, "36": 9, "39": 10, "40": 9, "41": 9, "44": 10,
  "45": 8, "46": 9, "47": 8, "48": 9, "49": 10, "51": 9, "52": 10,
  "54": 10, "55": 10, "56": 9, "57": 10, "58": 10, "60": 9, "61": 9,
  "62": 9, "63": 10, "64": 9, "65": 8, "66": 9, "81": 10, "82": 10,
  "84": 10, "86": 11, "90": 10, "91": 10, "92": 10, "94": 9, "95": 9,
  "98": 10, "212": 9, "213": 9, "216": 8, "218": 9, "234": 10, "250": 9,
  "254": 9, "255": 9, "256": 9, "260": 9, "263": 9, "351": 9, "352": 9,
  "353": 9, "354": 7, "355": 9, "356": 8, "358": 9, "380": 9, "420": 9,
  "421": 9, "880": 10, "886": 9, "960": 7, "961": 8, "966": 9, "971": 9,
  "972": 9, "977": 10, "992": 9, "994": 9, "995": 9, "998": 9,
};

// ── Smart number parser ───────────────────────────────────────────────────────
// Now always return both: the deduped array, invalids, duplicatesRemoved, originalCount, dedupedCount
function parsePhoneNumbers(raw) {
  const lines = raw
    .split(/[\n,;\t]+/)
    .map((s) => s.replace(/[\s\-().]/g, "").replace(/^\+/, "").replace(/^00/, ""))
    .filter(Boolean);

  const valid = [];
  const invalid = [];

  lines.forEach((digits) => {
    digits = digits.replace(/\D/g, "");
    if (!digits) return;

    let matched = false;
    // Try longest country code first (3 digit → 2 digit → 1 digit)
    for (const code of Object.keys(COUNTRY_LENGTHS).sort((a, b) => b.length - a.length)) {
      if (digits.startsWith(code)) {
        const localLen = COUNTRY_LENGTHS[code];
        if (digits.length === code.length + localLen) {
          matched = true;
          valid.push("+" + digits);
          break;
        }
      }
    }

    if (!matched) {
      // Accept if total length looks like a valid international number (7–15 digits)
      if (digits.length >= 10 && digits.length <= 15) {
        valid.push("+" + digits);
      } else {
        invalid.push(digits);
      }
    }
  });

  // Deduplicate and count duplicates
  const originalCount = valid.length;
  const deduped = [...new Set(valid)];
  const dedupedCount = deduped.length;
  const duplicatesRemoved = originalCount - dedupedCount;
  return { valid: deduped, invalid, duplicatesRemoved, originalCount, dedupedCount };
}

// ── Tab component ─────────────────────────────────────────────────────────────
function TabBtn({ active, onClick, icon, label }) {
  return (
    <button
      onClick={onClick}
      className={`flex items-center gap-2 px-4 py-2 text-[13px] font-medium rounded-md transition-all ${
        active
          ? "bg-[#ed7b00] text-white"
          : "bg-transparent text-[#6b7280] hover:bg-[#f3f4f6] dark:hover:bg-[#2a2a2a] dark:text-[#9ca3af]"
      }`}
    >
      {icon}
      {label}
    </button>
  );
}

// 🟩🟩🟩 SAMPLE FILE COMPONENT (with Download) 🟩🟩🟩
function SampleFileDisplay() {
  function handleDownload() {
    // Sample CSV data
    const csv =
      "phone,name\n" +
      "918765432101,Ramesh\n" +
      "919876543210,Leena\n" +
      "12131231234,John US\n";

    const blob = new Blob([csv], { type: "text/csv" });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "sample_contacts.csv";
    document.body.appendChild(a);
    a.click();
    window.URL.revokeObjectURL(url);
    a.remove();
  }

  return (
    <div className="mt-6 mb-1">
      <div className="flex items-center gap-2 mb-1">
        <p className="text-[12px] font-semibold text-[#374151] dark:text-[#d1d5db]">
          Sample Excel/CSV Format:
        </p>
        <button
          type="button"
          className="flex items-center gap-1 text-[12px] px-2.5 py-1 rounded bg-[#e1f5ee] border border-[#9fe1cb] text-[#ed7b00] font-semibold hover:bg-[#d1fae5] focus:outline-none active:scale-95 transition"
          onClick={handleDownload}
        >
          <FaDownload size={12} />
          Download sample
        </button>
      </div>
      <div className="overflow-x-auto border border-[#e5e7eb] dark:border-[#2d2d2d] rounded-md bg-[#fcfcfc] dark:bg-[#181a1c] max-w-[420px] mb-1">
        <table className="text-[12px] min-w-[240px]">
          <thead>
            <tr className="bg-[#f1f5f9] dark:bg-[#23272d]">
              <th className="px-3 py-1 font-bold border-r border-[#e5e7eb] dark:border-[#23272d] text-[#ed7b00]">phone</th>
              <th className="px-3 py-1 font-bold text-[#ed7b00]">name *</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td className="px-3 py-1 border-r border-[#e5e7eb] dark:border-[#23272d] text-[#374151] dark:text-[#d1d5db]">918765432101</td>
              <td className="px-3 py-1 text-[#374151] dark:text-[#d1d5db]">Ramesh</td>
            </tr>
            <tr>
              <td className="px-3 py-1 border-r border-[#e5e7eb] dark:border-[#23272d] text-[#374151] dark:text-[#d1d5db]">919876543210</td>
              <td className="px-3 py-1 text-[#374151] dark:text-[#d1d5db]">Leena</td>
            </tr>
            <tr>
              <td className="px-3 py-1 border-r border-[#e5e7eb] dark:border-[#23272d] text-[#374151] dark:text-[#d1d5db]">12131231234</td>
              <td className="px-3 py-1 text-[#374151] dark:text-[#d1d5db]">John US</td>
            </tr>
          </tbody>
        </table>
      </div>
      <p className="text-[11px] text-[#9ca3af]">
        <b>Required column:</b> <span className="text-[#ed7b00]">phone</span> (number, mobile also allowed).<br />
        You can include extra columns (e.g., <b>name</b>) for reference (they are ignored by the importer; only numbers are picked).
      </p>
    </div>
  );
}

// ── Main Component ────────────────────────────────────────────────────────────
export default function Campaigndetails({
  campaignData,
  setCampaignData,
  whatsappData,
  onNext,
  groups = [],
}) {
  const [activeTab, setActiveTab] = useState("manual");
  const [rawText, setRawText] = useState("");
  const [parsedNums, setParsedNums] = useState([]);
  const [invalidNums, setInvalidNums] = useState([]);
  const [parsedNumsOriginalLen, setParsedNumsOriginalLen] = useState(0); // original count for manual
  const [uploadedNums, setUploadedNums] = useState([]);
  const [uploadedNumsOriginalLen, setUploadedNumsOriginalLen] = useState(0); // original count for uploaded
  const [uploadFileName, setUploadFileName] = useState("");
  const [selectedGroups, setSelectedGroups] = useState([]);
  const [selectedGroupsOriginalLen, setSelectedGroupsOriginalLen] = useState(0); // original count for groups (could be used for custom group handling, if groups have duplicacy)
  const [dragOver, setDragOver] = useState(false);
  const [errors, setErrors] = useState({});
  const [totalDuplicatesRemoved, setTotalDuplicatesRemoved] = useState(0);
  const SECRET_KEY = "__globeomni_removed_duplicates__";
  const fileInputRef = useRef(null);

  // Helper for groups: get number of all group numbers before deduplication
  function calcAllGroupsOriginalCount(groupsArr) {
    return groupsArr.reduce((s, g) => s + (g.numbers?.length || 0), 0);
  }

  // =============== Deduplication: useEffect fix ===============
  useEffect(() => {
    // Calculate original source counts. If groups, always re-calculate since user may add/remove group and group members could overlap with other sources.
    const originalCount =
      parsedNumsOriginalLen +
      uploadedNumsOriginalLen +
      calcAllGroupsOriginalCount(selectedGroups);

    // Assemble one array, dedupe
    const allNums = [
      ...parsedNums,
      ...uploadedNums,
      ...selectedGroups.flatMap((g) => g.numbers || [])
    ];
    const deduped = [...new Set(allNums)];
    const dedupedCount = deduped.length;

    // The correct duplicates removed, always >= 0
    let duplicatesRemoved = originalCount - dedupedCount;
    if (duplicatesRemoved < 0) duplicatesRemoved = 0;

    setCampaignData((prev) => ({ ...prev, numbers: deduped }));
    setTotalDuplicatesRemoved(duplicatesRemoved);

    // Store to window
    if (typeof window !== "undefined") {
      window[SECRET_KEY] = duplicatesRemoved;
    }
  // eslint-disable-next-line
  }, [parsedNums, uploadedNums, selectedGroups, parsedNumsOriginalLen, uploadedNumsOriginalLen]);

  // =============== Manual ===============
  function handleTextChange(e) {
    const val = e.target.value;
    setRawText(val);
    const { valid, invalid, originalCount } = parsePhoneNumbers(val);
    setParsedNums(valid);
    setInvalidNums(invalid);
    setParsedNumsOriginalLen(originalCount);
  }

  // =============== File Upload ===============
  function processFile(file) {
    if (!file) return;
    const ext = file.name.split(".").pop().toLowerCase();
    const reader = new FileReader();

    reader.onload = (e) => {
      try {
        let numbers = [];
        if (ext === "csv") {
          const text = e.target.result;
          const lines = text.split("\n");
          const headers = lines[0].split(",").map((h) => h.trim().toLowerCase().replace(/["']/g, ""));
          const colIdx = headers.findIndex((h) =>
            ["phone", "number", "mobile", "contact", "whatsapp", "tel", "telephone", "phonenumber", "phone_number"].includes(h)
          );
          lines.slice(1).forEach((line) => {
            const cols = line.split(",");
            const val = colIdx >= 0 ? cols[colIdx] : cols[0];
            if (val) numbers.push(val.trim().replace(/["']/g, ""));
          });
        } else {
          const wb = XLSX.read(e.target.result, { type: "array" });
          const ws = wb.Sheets[wb.SheetNames[0]];
          const json = XLSX.utils.sheet_to_json(ws, { header: 1 });
          if (json.length < 1) return;
          const headers = json[0].map((h) => String(h).trim().toLowerCase());
          const colIdx = headers.findIndex((h) =>
            ["phone", "number", "mobile", "contact", "whatsapp", "tel", "telephone", "phonenumber", "phone_number"].includes(h)
          );
          json.slice(1).forEach((row) => {
            const val = colIdx >= 0 ? row[colIdx] : row[0];
            if (val !== undefined && val !== null) numbers.push(String(val).trim());
          });
        }

        const { valid, invalid, originalCount } = parsePhoneNumbers(numbers.join("\n"));
        setUploadedNums(valid);
        setUploadedNumsOriginalLen(originalCount);
        setUploadFileName(`${file.name} — ${valid.length} valid, ${invalid.length} skipped`);
      } catch (err) {
        setUploadFileName("Error reading file. Please check format.");
        setUploadedNums([]);
        setUploadedNumsOriginalLen(0);
      }
    };

    if (ext === "csv") {
      reader.readAsText(file);
    } else {
      reader.readAsArrayBuffer(file);
    }
  }

  function handleFileInput(e) {
    processFile(e.target.files?.[0]);
  }

  function handleDrop(e) {
    e.preventDefault();
    setDragOver(false);
    processFile(e.dataTransfer.files?.[0]);
  }

  function toggleGroup(group) {
    setSelectedGroups((prev) =>
      prev.find((g) => g.id === group.id)
        ? prev.filter((g) => g.id !== group.id)
        : [...prev, group]
    );
  }

  // This is just for display, real deduplication is useEffect above
  const totalCount =
    parsedNums.length +
    uploadedNums.length +
    selectedGroups.reduce((s, g) => s + (g.numbers?.length || 0), 0);

  function handleNext() {
    const errs = {};
    if (!campaignData.campaignName?.trim()) errs.campaignName = "Campaign name is required";
    if (!campaignData.phoneNumberId) errs.channel = "Please select a WhatsApp channel";
    if (totalCount === 0) errs.numbers = "Add at least one recipient number";
    if (Object.keys(errs).length) { setErrors(errs); return; }
    setErrors({});
    onNext();
  }

  function handleChannelChange(e) {
    const selected = whatsappData.find((w) => w.phone_number_id === e.target.value);
    setCampaignData((prev) => ({
      ...prev,
      phoneNumberId: selected?.phone_number_id || "",
      wabaId: selected?.waba_id || "",
      channelLabel: selected?.["Display Name"] || "",
    }));
  }

  return (
    <div className="w-full mt-4 flex flex-col gap-4">
      {/* ── Campaign Name + Channel ── */}
      <div className="bg-white dark:bg-[#1a1a1a] border border-[#e5e7eb] dark:border-[#2d2d2d] rounded-xl p-5 shadow-sm">
        <h3 className="text-[14px] font-semibold text-[#121519] dark:text-white flex items-center gap-2 mb-4">
          <FaUser className="text-[#ed7b00]" /> Campaign Details
        </h3>

        <div className="flex flex-col gap-3">
          {/* Name */}
          <div>
            <label className="text-[12px] font-medium text-[#6b7280] dark:text-[#9ca3af] mb-1 block">
              Campaign Name *
            </label>
            <input
              type="text"
              value={campaignData.campaignName}
              onChange={(e) => setCampaignData((p) => ({ ...p, campaignName: e.target.value }))}
              placeholder="e.g. Diwali Offer 2025"
              className={`w-full border rounded-lg px-3 py-2 text-[13px] dark:bg-[#111] dark:text-white outline-none focus:ring-2 focus:ring-[#ed7b00] transition ${
                errors.campaignName ? "border-red-400" : "border-[#d1d5db] dark:border-[#3a3a3a]"
              }`}
            />
            {errors.campaignName && (
              <p className="text-[11px] text-red-500 mt-1">{errors.campaignName}</p>
            )}
          </div>

          {/* Channel */}
          <div>
            <label className="text-[12px] font-medium text-[#6b7280] dark:text-[#9ca3af] mb-1 block">
              WhatsApp Channel *
            </label>
            <div className="relative">
              <select
                value={campaignData.phoneNumberId}
                onChange={handleChannelChange}
                className={`w-full border rounded-lg px-3 py-2 text-[13px] appearance-none dark:bg-[#111] dark:text-white outline-none focus:ring-2 focus:ring-[#ed7b00] transition ${
                  errors.channel ? "border-red-400" : "border-[#d1d5db] dark:border-[#3a3a3a]"
                }`}
              >
                <option value="">— Select channel —</option>
                {whatsappData.map((w) => (
                  <option key={w.phone_number_id} value={w.phone_number_id}>
                    {w["Display Name"]} __ {w["WABA Number"] ? ` ${w["WABA Number"]}` : ""}
                  </option>
                ))}
              </select>
              <FaChevronDown className="absolute right-3 top-3 text-[#9ca3af] pointer-events-none text-[11px]" />
            </div>
            {errors.channel && (
              <p className="text-[11px] text-red-500 mt-1">{errors.channel}</p>
            )}
          </div>
        </div>
      </div>

      {/* ── Recipients Section ── */}
      <div className="bg-white dark:bg-[#1a1a1a] border border-[#e5e7eb] dark:border-[#2d2d2d] rounded-xl p-5 shadow-sm">
        <div className="flex items-center justify-between mb-4">
          <h3 className="text-[14px] font-semibold text-[#121519] dark:text-white flex items-center gap-2">
            <FaUsers className="text-[#ed7b00]" /> Recipients
          </h3>
          {totalCount > 0 && (
            <div className="flex items-center gap-1.5 bg-[#e1f5ee] text-[#0f6e56] text-[12px] font-semibold px-3 py-1 rounded-full border border-[#9fe1cb]">
              <FaCheckCircle className="text-[10px]" />
              {totalCount.toLocaleString()} numbers
            </div>
          )}
        </div>

        {/* Tabs */}
        <div className="flex gap-1 bg-[#f3f4f6] dark:bg-[#222] rounded-lg p-1 mb-4">
          <TabBtn
            active={activeTab === "manual"}
            onClick={() => setActiveTab("manual")}
            icon={<FaKeyboard className="text-[11px]" />}
            label="Manual Entry"
          />
          <TabBtn
            active={activeTab === "excel"}
            onClick={() => setActiveTab("excel")}
            icon={<FaFileExcel className="text-[11px]" />}
            label="Upload File"
          />
          <TabBtn
            active={activeTab === "groups"}
            onClick={() => setActiveTab("groups")}
            icon={<FaUsers className="text-[11px]" />}
            label={`Groups${selectedGroups.length > 0 ? ` (${selectedGroups.length})` : ""}`}
          />
        </div>

        {/* ── Manual Entry ── */}
        {activeTab === "manual" && (
          <div>
            <label className="text-[12px] text-[#6b7280] dark:text-[#9ca3af] font-medium block mb-1">
              Enter phone numbers with country code, one per line
            </label>
            <textarea
              value={rawText}
              onChange={handleTextChange}
              rows={8}
              placeholder={"918747837839\n14155550100\n447911123456\n8613800138000\n..."}
              className="w-full border border-[#d1d5db] dark:border-[#3a3a3a] rounded-lg px-3 py-2 text-[12px] font-mono leading-6 dark:bg-[#111] dark:text-[#e5e7eb] outline-none focus:ring-2 focus:ring-[#ed7b00] resize-y transition"
            />
            <p className="text-[11px] text-[#9ca3af] mt-1">
              Supports: <code className="bg-[#f3f4f6] dark:bg-[#222] px-1 rounded">918747837839</code> ·{" "}
              <code className="bg-[#f3f4f6] dark:bg-[#222] px-1 rounded">+91 87478 37839</code> ·{" "}
              <code className="bg-[#f3f4f6] dark:bg-[#222] px-1 rounded">00918747837839</code> — comma/newline separated
            </p>

            {/* Stats */}
            {(parsedNums.length > 0 || invalidNums.length > 0) && (
              <div className="mt-3 flex flex-wrap gap-2">
                {parsedNums.length > 0 && (
                  <span className="flex items-center gap-1 bg-[#e1f5ee] text-[#0f6e56] text-[11px] font-medium px-2.5 py-1 rounded-full border border-[#9fe1cb]">
                    <FaCheckCircle /> {parsedNums.length} valid
                  </span>
                )}
                {invalidNums.length > 0 && (
                  <span className="flex items-center gap-1 bg-[#fef3c7] text-[#92400e] text-[11px] font-medium px-2.5 py-1 rounded-full border border-[#fcd34d]">
                    <FaExclamationTriangle /> {invalidNums.length} skipped (too short/invalid)
                  </span>
                )}
              </div>
            )}

            {/* Preview chips */}
            {parsedNums.length > 0 && (
              <div className="mt-3 flex flex-wrap gap-1.5 max-h-[80px] overflow-y-auto">
                {parsedNums.slice(0, 20).map((n) => (
                  <span
                    key={n}
                    className="text-[11px] bg-[#f3f4f6] dark:bg-[#2a2a2a] text-[#374151] dark:text-[#d1d5db] border border-[#e5e7eb] dark:border-[#3a3a3a] rounded-md px-2 py-0.5 font-mono"
                  >
                    {n}
                  </span>
                ))}
                {parsedNums.length > 20 && (
                  <span className="text-[11px] bg-[#e1f5ee] text-[#0f6e56] border border-[#9fe1cb] rounded-md px-2 py-0.5 font-medium">
                    +{parsedNums.length - 20} more
                  </span>
                )}
              </div>
            )}

            {parsedNums.length > 0 && (
              <button
                onClick={() => { setRawText(""); setParsedNums([]); setInvalidNums([]); setParsedNumsOriginalLen(0); }}
                className="mt-2 flex items-center gap-1 text-[11px] text-red-400 hover:text-red-600 transition"
              >
                <FaTrash className="text-[10px]" /> Clear all
              </button>
            )}
          </div>
        )}

        {/* ── Excel Upload ── */}
        {activeTab === "excel" && (
          <div>
            <div
              className={`border-2 border-dashed rounded-xl p-8 text-center cursor-pointer transition-all ${
                dragOver
                  ? "border-[#ed7b00] bg-[#e1f5ee]"
                  : "border-[#d1d5db] dark:border-[#3a3a3a] hover:border-[#ed7b00] hover:bg-[#f0fdf4]"
              }`}
              onDragOver={(e) => { e.preventDefault(); setDragOver(true); }}
              onDragLeave={() => setDragOver(false)}
              onDrop={handleDrop}
              onClick={() => fileInputRef.current?.click()}
            >
              <FaFileExcel className="text-[40px] text-[#ed7b00] mx-auto mb-3" />
              <p className="text-[14px] font-semibold text-[#374151] dark:text-[#d1d5db]">
                Drop file here or click to browse
              </p>
              <p className="text-[12px] text-[#9ca3af] mt-1">
                .xlsx · .xls · .csv — column named{" "}
                <code className="bg-[#f3f4f6] dark:bg-[#222] px-1 rounded">phone</code>,{" "}
                <code className="bg-[#f3f4f6] dark:bg-[#222] px-1 rounded">number</code>, or{" "}
                <code className="bg-[#f3f4f6] dark:bg-[#222] px-1 rounded">mobile</code>
              </p>
              <input
                ref={fileInputRef}
                type="file"
                accept=".xlsx,.xls,.csv"
                className="hidden"
                onChange={handleFileInput}
              />
            </div>

            {/* Sample File Table and Download */}
          

            {uploadFileName && (
              <div className="mt-3 flex items-start gap-2 bg-[#f0fdf4] border border-[#9fe1cb] rounded-lg px-3 py-2">
                <FaCheckCircle className="text-[#ed7b00] mt-0.5 shrink-0" />
                <div>
                  <p className="text-[12px] font-medium text-[#0f6e56]">{uploadFileName}</p>
                  {uploadedNums.length > 0 && (
                    <div className="flex flex-wrap gap-1 mt-1">
                      {uploadedNums.slice(0, 10).map((n) => (
                        <span key={n} className="text-[10px] bg-white border border-[#d1d5db] rounded px-1.5 font-mono text-[#374151]">
                          {n}
                        </span>
                      ))}
                      {uploadedNums.length > 10 && (
                        <span className="text-[10px] text-[#0f6e56] font-medium">
                          +{uploadedNums.length - 10} more
                        </span>
                      )}
                    </div>
                  )}
                </div>
                <button
                  onClick={() => { setUploadedNums([]); setUploadedNumsOriginalLen(0); setUploadFileName(""); if (fileInputRef.current) fileInputRef.current.value = ""; }}
                  className="ml-auto text-red-400 hover:text-red-600 transition"
                >
                  <FaTrash className="text-[11px]" />
                </button>
              </div>
            )}

            <p className="text-[11px] text-[#9ca3af] mt-3">
              Numbers will be parsed with country-code detection and deduplicated automatically.
            </p>
          </div>
        )}

        {/* ── Groups ── */}
        {activeTab === "groups" && (
          <div>
            {groups.length === 0 ? (
              <div className="text-center py-10 text-[#9ca3af]">
                <FaUsers className="text-[40px] mx-auto mb-3 opacity-40" />
                <p className="text-[13px]">No groups found.</p>
                <p className="text-[11px] mt-1">Create contact groups from the Contacts page first.</p>
              </div>
            ) : (
              <>
                <div className="grid grid-cols-2 md:grid-cols-3 gap-2">
                  {groups.map((group) => {
                    const isSelected = selectedGroups.find((g) => g.id === group.id);
                    return (
                      <div
                        key={group.id}
                        onClick={() => toggleGroup(group)}
                        className={`relative cursor-pointer border rounded-xl p-3 transition-all select-none ${
                          isSelected
                            ? "border-[#ed7b00] bg-[#e1f5ee] dark:bg-[#0a2a22]"
                            : "border-[#e5e7eb] dark:border-[#2d2d2d] hover:border-[#ed7b00] hover:bg-[#f0fdf4] dark:hover:bg-[#0a2a22]"
                        }`}
                      >
                        {/* Checkbox indicator */}
                        <div className={`absolute top-2.5 right-2.5 w-4 h-4 rounded-full border flex items-center justify-center transition-all ${
                          isSelected ? "bg-[#ed7b00] border-[#ed7b00]" : "border-[#d1d5db] dark:border-[#4a4a4a] bg-white dark:bg-[#111]"
                        }`}>
                          {isSelected && (
                            <svg width="8" height="6" viewBox="0 0 8 6" fill="none">
                              <path d="M1 3L3 5L7 1" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                            </svg>
                          )}
                        </div>
                        <FaUsers className={`text-[18px] mb-1.5 ${isSelected ? "text-[#ed7b00]" : "text-[#9ca3af]"}`} />
                        <p className={`text-[13px] font-semibold truncate pr-5 ${isSelected ? "text-[#0f6e56]" : "text-[#374151] dark:text-[#d1d5db]"}`}>
                          {group.name}
                        </p>
                        <p className={`text-[11px] mt-0.5 ${isSelected ? "text-[#0f6e56]" : "text-[#9ca3af]"}`}>
                          {(group.numbers?.length || group.count || 0).toLocaleString()} contacts
                        </p>
                      </div>
                    );
                  })}
                </div>

                {selectedGroups.length > 0 && (
                  <div className="mt-3 flex items-center justify-between bg-[#e1f5ee] border border-[#9fe1cb] rounded-lg px-3 py-2">
                    <div className="flex flex-wrap gap-1">
                      {selectedGroups.map((g) => (
                        <span key={g.id} className="text-[11px] bg-white border border-[#9fe1cb] rounded-full px-2 py-0.5 text-[#0f6e56] font-medium">
                          {g.name}
                        </span>
                      ))}
                    </div>
                    <span className="text-[12px] font-semibold text-[#0f6e56] shrink-0 ml-2">
                      {selectedGroups.reduce((s, g) => s + (g.numbers?.length || g.count || 0), 0).toLocaleString()} total
                    </span>
                  </div>
                )}
              </>
            )}
          </div>
        )}

        {/* Source summary pills */}
        {(parsedNums.length > 0 || uploadedNums.length > 0 || selectedGroups.length > 0) && (
          <div className="mt-4 pt-4 border-t border-[#f3f4f6] dark:border-[#2d2d2d] flex flex-wrap gap-2 items-center">
            <span className="text-[11px] text-[#9ca3af] font-medium">Sources:</span>
            {parsedNums.length > 0 && (
              <span className="text-[11px] bg-[#dbeafe] text-[#1e40af] px-2 py-0.5 rounded-full border border-[#93c5fd]">
                ✏️ {parsedNums.length} manual
              </span>
            )}
            {uploadedNums.length > 0 && (
              <span className="text-[11px] bg-[#ede9fe] text-[#5b21b6] px-2 py-0.5 rounded-full border border-[#c4b5fd]">
                📊 {uploadedNums.length} from file
              </span>
            )}
            {selectedGroups.length > 0 && (
              <span className="text-[11px] bg-[#fef3c7] text-[#92400e] px-2 py-0.5 rounded-full border border-[#fcd34d]">
                👥 {selectedGroups.reduce((s, g) => s + (g.numbers?.length || g.count || 0), 0).toLocaleString()} from {selectedGroups.length} group(s)
              </span>
            )}
            <span className="ml-auto text-[12px] font-bold text-[#ed7b00]">
              = {totalCount.toLocaleString()} total
            </span>
            {(typeof window !== "undefined") && (typeof totalDuplicatesRemoved === "number" && totalDuplicatesRemoved > 0) && (
              <span className="text-[11px] bg-[#fee2e2] text-[#b91c1c] px-2 py-0.5 rounded-full border border-[#fecaca] font-medium ml-2 hidden">
                Removed {totalDuplicatesRemoved} duplicate{totalDuplicatesRemoved > 1 ? "s" : ""}
              </span>
            )}
          </div>
        )}

        {errors.numbers && (
          <p className="text-[11px] text-red-500 mt-2 flex items-center gap-1">
            <FaExclamationTriangle /> {errors.numbers}
          </p>
        )}
      </div>

      {/* ── Next button ── */}
      <div className="flex justify-end">
        <button
          onClick={handleNext}
          className="bg-[#ed7b00] hover:bg-[#a75b08] text-white font-semibold text-[13px] px-6 py-2.5 rounded-xl transition-all active:scale-95 flex items-center gap-2 shadow-sm"
        >
          Next: Template
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
            <line x1="5" y1="12" x2="19" y2="12"/><polyline points="12 5 19 12 12 19"/>
          </svg>
        </button>
      </div>
    </div>
  );
}